import React from 'react'
import classNames from 'classnames'
import css from './flex-column.module.css'

function FlexColumn ({ className, style, children }) {
  return <div className={classNames(css.flexColumn, className)} style={style}>{children}</div>
}

export default FlexColumn
